export default {
  home: "Homepage",
  companyProfile: "Company Profile",
  jobPost: "Job Post",
  booking: "Booking",
};
